<template>
  <div class="card" data-cy="productCard">
    <router-link :to="{ path: `${path}` }">
      <slot name="product-logo"></slot>
      <h4 class="title mt-0">{{ title }} <slot name="product-icon"></slot></h4>
      <p class="text" v-html-safe="text"></p>
      <span class="view-details">{{ $t('message.spotlightV2.categories.productCardButtonText') }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SpotlightProductCardLink',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null,
    },
    path: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.card {
  border-radius: 6px;
  border: 1px solid rgb(218, 226, 234);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  position: relative;
  margin-bottom: 0.5rem;
  a {
    padding: 24px 16px;
    text-decoration: none;
    color: $primary-dark-text;
    &:hover {
      text-decoration: none;
    }
    p {
      color: #4b5863;
    }
    .view-details {
      color: $primary;
      letter-spacing: 0px;
      line-height: 20px;
      text-decoration: underline;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
